import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Color } from '@figure/frontlib-gui';

const Text = styled.span`
  padding-left: 5px;
  color: ${Color.LIGHT_GREY};
`;

const Retry = styled.span`
  text-decoration: underline;
  padding-left: 5px;
  cursor: pointer;
  white-space: nowrap;

  svg {
    vertical-align: bottom;
  }
`;

const PlaidError = ({ text, handleRetry }) => (
  <Text>
    {text}
    {typeof handleRetry === 'function' && (
      <Retry onClick={handleRetry}>
        Retry
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 7L15 12L9 17.5" stroke={Color.MELLOW_YELLOW} />
        </svg>
      </Retry>
    )}
  </Text>
);

PlaidError.propTypes = {
  text: PropTypes.string.isRequired,
  handleRetry: PropTypes.func,
};

PlaidError.defaultProps = {
  handleRetry: null,
};

export default PlaidError;
